import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgAsset4 = (props) => /* @__PURE__ */ _jsx("svg", {
	width: "1em",
	height: "1em",
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M14.75 4.75H10.75M14.75 0.75H10.75V4.75M14.75 0.75H7.75H0.75V14.75H7.75H14.75V0.75ZM10.75 4.75V10.75M10.75 10.75V14.75M10.75 10.75H14.75M10.75 10.75H4.75M4.75 4.75V10.75M4.75 4.75H0.75M4.75 4.75V0.75M4.75 10.75V14.75M4.75 10.75H0.75",
		stroke: "#212121",
		strokeWidth: 1.5,
		strokeLinejoin: "bevel"
	})
});
export default SvgAsset4;
